import styled from 'styled-components';

import theme from './theme';
import { BottomServiceVariants } from './types';

//TODO handle colors when background switches
export const mapVariantToColor = (variant: BottomServiceVariants) => {
  switch (variant) {
    case BottomServiceVariants.IN_PROGRESS:
      return Styles.color.black;
    case BottomServiceVariants.DEFAULT:
    default:
      return Styles.color.bsmPrimary;
  }
};

export const mapTextToColor = (variant: BottomServiceVariants) => {
  switch (variant) {
    case BottomServiceVariants.IN_PROGRESS:
      return Styles.color.white;
    case BottomServiceVariants.DEFAULT:
    default:
      return theme.text.color;
  }
};

export const ButtonContainer = styled.div`
  grid-area: button;
  align-self: center;
  justify-self: center;
  display: flex;
  & > :not(:last-child) {
    margin-right: 0.625rem;
  }
`;

export const Container = styled.div<{ variant: BottomServiceVariants }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.475rem;
  height: 4.125rem;
  background: ${props => mapVariantToColor(props.variant)};
  cursor: pointer;
  box-shadow: 0px 1px 4px ${Styles.color.background};
`;

export const LocationOverlayButton = styled.button`
  grid-area: 1 / 1 / span 3 / span 2;
  width: auto;
  min-height: 100%;
  opacity: 0;
  z-index: ${Styles.zIndex.top};
  margin-left: -20%;
  ${Styles.desktop`
    margin-left: -5%;
  `}
`;
export const CartOverlayButton = styled.button`
  grid-area: button;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: ${Styles.zIndex.top};
`;

export const IconContainer = styled.div`
  align-self: center;
  justify-self: baseline;
  grid-area: icon;
`;

export const BottomServiceWrapper = styled.div`
  max-width: ${Styles.layout.sectionMaxWidth};
  color: ${theme.bottomServiceWrapper.color};
  display: grid;
  grid-template-areas:
    '. heading button'
    'icon heading button'
    'icon details button';
  grid-template-columns: 2.2rem auto max-content;
  width: 100%;
`;

export const Heading = styled.div<{ variant: BottomServiceVariants }>`
  grid-area: heading;
  font-family: ${Styles.fontFamily.base};
  font-size: 1rem;
  color: ${props => mapTextToColor(props.variant)};
  padding: 0 0.625rem;
  text-transform: ${theme.textTransform};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 0.75rem;
`;

export const Details = styled.div<{ variant: BottomServiceVariants }>`
  grid-area: details;
  color: ${props => mapTextToColor(props.variant)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 0.625rem;
`;

export const AddressStyle = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 0.75rem;
`;

export const Underline = styled.div`
  background-color: ${theme.underline.color};
  width: 100%;
  height: 0.125rem;
`;

export const LocationStyle = styled.div`
  display: flex;
  justify-content: space-between;

  ${Styles.desktop`
    height: 1.5rem;
  `}
`;
